<template>
  <component :is="layout">
    <router-view></router-view>
  </component>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_APPLICATION, FETCH_APPLICATIONS, FETCH_INVESTOR_FORM } from "@/store/actions.type";
import {
  SET_ApplicationMenuActive,
  SET_LabelMenuActive,
  SET_HashId,
  SET_LabelApp
} from "@/store/mutations.type";
const default_layout = "default";

export default {
  name: "home",
  data() {
    return {
      pending: ["3", "6", "8"]
    };
  },
  mounted() {
    if (this.session == null || this.session.startup_application == null) {
      if(this.$route.query.app_id){
      this.app_id = this.$route.query.app_id;
      }else if(this.$route.params.app_id){
        this.app_id = this.$route.params.app_id;
      }else{
        this.app_id = window.localStorage.getItem("hash_id");
      }
    }
  },
  computed: {
    ...mapGetters([
      "session",
      "ApplicationMenuActive",
      "LabelMenuActive",
      "hashId",
      "LabelApplication",
      "currentUser"
    ]),
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    }
  },
  watch: {
    session() {
      if (this.session == null || this.session.startup_application == null) {
          if (this.currentUser.role != 'Investor') {
            this.$router.push({ name: "home" });
          }
      }
    },
    currentUser() {
      if (this.currentUser.role == 'Investor') {
        this.$store.dispatch(FETCH_INVESTOR_FORM).then(data => {
          if (data.data.investorFormData == null) {
            this.$router.push({ name: "InvestorFormPrincipal" });
          }
        });
      }else if (this.currentUser.role != 'sso' && this.currentUser.role != 'form-builder') {
        this.$store.dispatch(FETCH_APPLICATION,this.app_id);
      }
    }
  }
};
</script>
